import { tooltipClasses } from '@mui/material'

type TExportOptionStylesProps = {
	isDisabled?: boolean;
	isSelected?: boolean;
};

const styles = {
	comingSoon: {
		color: "var(--black)",
		fontSize: "12px",
		fontWeight: 600,
		lineHeight: 1.5,
	},
	description: ({ isDisabled }: TExportOptionStylesProps) => ({
		color: isDisabled ? "var(--dark_grey)" : "var(--text-grey)",
		cursor: "text",
		fontSize: "12px",
		marginTop: "8px",
		userSelect: "text",
	}),
	icon: ({ isDisabled }: TExportOptionStylesProps) => ({
		color: isDisabled ? "var(--dark_grey)" : "var(--black)",
	}),
	iconWrapper: {
		position: "relative",
	},
	info: {
		alignItems: "center",
		flexDirection: "row",
		gap: "4px",
		position: "absolute",
		right: "16px",
		top: "16px",
	},
	infoIcon: { cursor: "pointer", fontSize: "16px" },
	infoTooltip: {
		[`& .${tooltipClasses.tooltip}`]: {
			maxWidth: "320px"
		},
		lineHeight: 1.5
	},
	title: ({ isDisabled }: TExportOptionStylesProps) => ({
		color: isDisabled ? "var(--dark_grey)" : "var(--black)",
		fontSize: "16px",
		fontWeight: 600,
		lineHeight: 1.5,
		marginTop: "16px",
		userSelect: "text",
		whiteSpace: "pre-line",
	}),
	wrapper: ({ isDisabled, isSelected }: TExportOptionStylesProps) => ({
		"&:hover": {
			boxShadow: isDisabled ? "none" : "0px 4px 30px 0px #72798A1A",
		},
		border: "1px solid",
		borderColor: isSelected ? "var(--primary)" : "var(--grey_nuance)",
		borderRadius: "8px",
		cursor: isDisabled ? "not-allowed" : "pointer",
		height: "100%",
		outline: isSelected ? "3px solid var(--primary)" : "none",
		outlineOffset: "-2px",
		padding: "16px",
		position: "relative",
		transition: "0.2s ease-in-out",
		userSelect: "none",
		width: "100%",
	}),
};

export default styles;